import { useContext } from 'react';
import { AuthContext } from './SessionProvider';

export const useAuth = () => useContext(AuthContext);
